/* ==========================================================================
   Icon Text Section
   Path: assets/icon-text-section.js
   Loaded from: sections/icon-text-section.liquid
   Handles: drag-to-scroll for desktop when the scrollable row option is
   enabled, and Shopify theme editor live refresh support.
   ========================================================================== */

(function () {
  'use strict';

  function setupDragToScroll(root) {
    var wrapper = root.querySelector('.icon-text__track-wrapper');
    if (!wrapper || wrapper.dataset.dragBound) return;
    wrapper.dataset.dragBound = 'true';

    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;

    function isScrollEnabledForViewport() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        return root.classList.contains('icon-text--scroll-mobile');
      }
      return root.classList.contains('icon-text--scroll-desktop');
    }

    wrapper.addEventListener('pointerdown', function (e) {
      if (!isScrollEnabledForViewport()) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScrollLeft = wrapper.scrollLeft;
      wrapper.setPointerCapture(e.pointerId);
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      wrapper.scrollLeft = startScrollLeft - delta;
    });

    function endDrag() {
      isDown = false;
    }
    wrapper.addEventListener('pointerup', endDrag);
    wrapper.addEventListener('pointercancel', endDrag);
    wrapper.addEventListener('pointerleave', endDrag);

    // Prevent accidental link clicks right after a drag.
    wrapper.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function setupSection(root) {
    if (!root) return;

    var scrollDesktop = root.dataset.scrollDesktop === 'true';
    var scrollMobile = root.dataset.scrollMobile === 'true';

    if (scrollDesktop || scrollMobile) {
      setupDragToScroll(root);
    }
  }

  function initAll(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll('.icon-text');
    sections.forEach(function (section) {
      setupSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Re-init when a merchant edits this section in the Shopify theme editor,
  // since settings changes reload the section markup via AJAX.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.icon-text')) {
      initAll(event.target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('.icon-text')) {
      initAll(event.target);
    }
  });
})();